import React from 'react';

interface SkeletonLoaderProps {
  type: 'metrics' | 'table';
  count?: number;
}

export default function SkeletonLoader({ type, count = 3 }: SkeletonLoaderProps) {
  const items = Array.from({ length: count });

  if (type === 'metrics') {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 w-full lg:w-auto animate-pulse">
        {items.map((_, i) => (
          <div key={i} className="flex flex-col lg:items-end space-y-1">
            <div className="h-3 bg-gray-200 rounded w-20"></div>
            <div className="h-6 bg-gray-200 rounded w-12 mt-1"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="w-full space-y-4 animate-pulse p-6 bg-white rounded-xl">
        {/* Table header skeleton */}
        <div className="flex items-center space-x-4 border-b border-gray-100 pb-4">
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/6"></div>
          <div className="h-4 bg-gray-200 rounded w-1/12 ml-auto"></div>
        </div>
        {/* Table body rows skeleton */}
        {items.map((_, i) => (
          <div key={i} className="flex items-center space-x-4 py-3 border-b border-gray-50 last:border-0">
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
            <div className="h-4 bg-gray-150 rounded w-1/3"></div>
            <div className="h-4 bg-gray-100 rounded w-1/6"></div>
            <div className="h-6 bg-gray-200 rounded-lg w-20 shrink-0 ml-auto flex gap-2 justify-end"></div>
          </div>
        ))}
      </div>
    );
  }

  return null;
}
